import { SprayEventApplicationType, SprayEventWeather } from './types';

export const SPRAY_EVENTS_LOAD_REQUESTED = 'SPRAY_EVENTS_LOAD_REQUESTED';
export const SPRAY_EVENTS_LOAD_SUCCEEDED = 'SPRAY_EVENTS_LOAD_SUCCEEDED';
export const SPRAY_EVENTS_LOAD_FAILED = 'SPRAY_EVENTS_LOAD_FAILED';
export const SPRAY_EVENTS_LOAD_CANCELED = 'SPRAY_EVENTS_LOAD_CANCELED';
export const SPRAY_EVENT_CREATE_REQUESTED = 'SPRAY_EVENT_CREATE_REQUESTED';
export const SPRAY_EVENT_CREATE_SUCCEEDED = 'SPRAY_EVENT_CREATE_SUCCEEDED';
export const SPRAY_EVENT_CREATE_FAILED = 'SPRAY_EVENT_CREATE_FAILED';
export const SPRAY_EVENTS_SET = 'SPRAY_EVENTS_SET';
export const SPRAY_EVENTS_DELETE = 'SPRAY_EVENTS_DELETE';
export const SPRAY_EVENT_SET = 'SPRAY_EVENT_SET';
export const SPRAY_EVENT_DELETE_REQUESTED = 'SPRAY_EVENT_DELETE_REQUESTED';
export const SPRAY_EVENT_DELETE_FAILED = 'SPRAY_EVENT_DELETE_FAILED';
export const SPRAY_EVENT_DELETE_SUCCEEDED = 'SPRAY_EVENT_DELETE_SUCCEEDED';
export const SPRAY_EVENT_UPDATE_REQUESTED = 'SPRAY_EVENT_UPDATE_REQUESTED';
export const SPRAY_EVENT_UPDATE_SUCCEEDED = 'SPRAY_EVENT_UPDATE_SUCCEEDED';
export const SPRAY_EVENT_UPDATE_FAILED = 'SPRAY_EVENT_UPDATE_FAILED';
export const SPRAY_EVENTS_COMPLETE_REQUESTED =
    'SPRAY_EVENTS_COMPLETE_UPDATE_REQUESTED';
export const SPRAY_EVENTS_COMPLETE_SUCCEEDED =
    'SPRAY_EVENTS_COMPLETE_UPDATE_SUCCEEDED';
export const SPRAY_EVENTS_COMPLETE_FAILED =
    'SPRAY_EVENTS_COMPLETE_UPDATE_FAILED';
export const SPRAY_EVENT_UNCOMPLETE_REQUESTED =
    'SPRAY_EVENT_UNCOMPLETE_UPDATE_REQUESTED';
export const SPRAY_EVENT_UNCOMPLETE_SUCCEEDED =
    'SPRAY_EVENT_UNCOMPLETE_UPDATE_SUCCEEDED';
export const SPRAY_EVENT_UNCOMPLETE_FAILED =
    'SPRAY_EVENT_UNCOMPLETE_UPDATE_FAILED';

export const SPRAY_EVENTS_LOAD_NAMESPACE = 'SPRAY_EVENTS_LOAD';
export const SPRAY_EVENT_UNCOMPLETE_NAMESPACE = 'SPRAY_EVENT_UNCOMPLETE_UPDATE';
export const SPRAY_EVENTS_NAMESPACE = 'SPRAY_EVENTS_NAMESPACE';

export const SPRAY_EVENT_APPLICATION_TYPE_DROPDOWN_OPTIONS = [
    {
        key: SprayEventApplicationType.STANDARD,
        text: 'Standard',
        value: SprayEventApplicationType.STANDARD
    },
    {
        key: SprayEventApplicationType.MULTIOPERATOR,
        text: 'Multi-Operator',
        value: SprayEventApplicationType.MULTIOPERATOR
    },
    {
        key: SprayEventApplicationType.TWODIMENSION,
        text: '2D',
        value: SprayEventApplicationType.TWODIMENSION
    }
];

export const SPRAY_EVENT_WEATHER_DROPDOWN_OPTIONS = [
    {
        key: SprayEventWeather.CALM,
        text: 'Calm',
        value: SprayEventWeather.CALM
    },
    {
        key: SprayEventWeather.BREEZY,
        text: 'Breezy',
        value: SprayEventWeather.BREEZY
    },
    {
        key: SprayEventWeather.WINDY,
        text: 'Windy',
        value: SprayEventWeather.WINDY
    },
    {
        key: SprayEventWeather.DRY,
        text: 'Dry',
        value: SprayEventWeather.DRY
    },
    {
        key: SprayEventWeather.SHOWERY,
        text: 'Showery',
        value: SprayEventWeather.SHOWERY
    },
    {
        key: SprayEventWeather.RAIN,
        text: 'Rain',
        value: SprayEventWeather.RAIN
    }
];

export enum ProfileFieldName {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
    MOBILE_NUMBER = 'mobileNumber',
    PAYROLL_NUMBER = 'datacomId',
    GROUPS = 'groupIds',
    ROLES = 'roleIds',
    SPRAY_OPERATOR = 'isSprayOperator'
}

export const EQUIPMENT_FILTER_TYPE = 'EQUIPMENT_FILTER_TYPE';
export const PRODUCT_FILTER_TYPE = 'PRODUCT_FILTER_TYPE';
export const DATE_RANGE_FILTER_TYPE = 'DATE_RANGE_FILTER_TYPE';
export const APPLICATION_RATE_FILTER_TYPE = 'APPLICATION_RATE_FILTER_TYPE';
export const ENTITIES_FILTER_TYPE = 'ENTITIES_FILTER_TYPE';
export const INNER_ENTITIES_FILTER_TYPE = 'INNER_ENTITIES_FILTER_TYPE';
export const DATE_FILTER_TYPE = 'DATE_FILTER_TYPE';

export const HALF_THE_CALCULATION = 2;
